import React, {FC} from "react";

import style from './content.module.scss';

export const Content: FC = () =>
{
    return (
        <div className={style.content} id={'content'}>
            <div className={style.textWrap}>
                <a id="Overview"><h1>VoiceRoomsBot</h1></a>
                <h2>Description</h2>
                <p><i>
                    VoiceRoomsBot (VRB) created for voice channel manimulation in Discord. The key purpose is granting members tools with voice channel control.
                </i></p>
                <a id="Idea"><h2>Idea</h2></a>
                <p>
                    <p><i>Main goal is  granting members tools with voice channel control, without admin assistance</i></p>
                    <p>
                        To understand how it works you need to know about several main entities that are the main elements of the VRB
                    </p>
                    <p>
                        Space - Space which contains rooms. <br/>
                        Room - Contains voice channel and it’s owner. <br/>
                        Text - Text channel which is also part of room. <br/>
                    </p>
                    <p>
                        VRB has a permissions system that can be delegated to some members or roles. <br/>
                        Permissions can flexibly restrict user access to commands <br/>
                        The permissions are divided into 3 groups:
                    </p>
                    <p>
                        Main Permission - Permissions for all server members and all spaces. <br/>
                        Space Permission - Permissions for particular space. <br/>
                        Special Permission - Permission for special user or role. <br/>
                    </p>
                    <a id="Process"><h1>Proccess</h1></a>
                    <p>
                        After adding the bot, you need to create a space using the special command. Then the bot will create the space with a voice channel. After entering the channel, the bot creates a new one, which will move you. <br/>
                        The channel name will be set automatically (by default is the user nickname). The voice channel (Room) is private. The user who created the room is the room's owner. <br/>
                        The room owner has functions to control its room. <br/>
                        The bot deletes left empty rooms. <br/>
                        The user can control his room with commands in a specific text channel (the list of commands is presented below). <br/>
                        Also, users can create a text channel to text messaging with other users from the private room. The created text channel is the part of the room and it can be viewed by users from the same room only. Not @everyone. <br/>
                        The user-created text channel can be moderate with specific text commands within this channel <br/>
                        You can create several spaces. <br/>
                        It doesn't matter where the channel for creating rooms is located
                    </p>
                    <a id="Permissions"><h1>Permissions</h1></a>
                    <p><i>The rights to use commands hierarchically structured.</i></p>
                    <p>
                        ↓ Main permissions <br/>
                        ↓ Space permissions <br/>
                        ↓ Special permissions <br/>
                    </p>
                    <p><i>Highest priority is Special permissions.</i></p>
                    <p>
                        Example: <br/>
                        <i>Main permission</i> - no one can change the room's name. <br/>
                        <i>Space permission</i> - users in space named “Space” can change rooms name. <br/>
                        <i>Special permission</i> - Users who have a @permit role can change rooms name. <br/>
                    </p>
                    <p>
                        So, all server members cannot change the names of their rooms except users with the 'permit' role and those users who are in the space.
                    </p>
                </p>
                <h2>Permissions list</h2>
                <p>
                    <ul>
                        <li><i>create</i> - Creating room.</li>
                        <li><i>manage</i> - Control voice channel (discord button).</li>
                        <li><i>text</i> - Creating a text channel and controlling it.</li>
                        <li><i>name</i> - The changing name of the room (voice channel).</li>
                        <li><i>limit</i> - Changing the users limit in the room (voice channel).</li>
                        <li><i>mute</i> - Muting a user (voice channel).</li>
                        <li><i>unmute</i> - Unmuting users (voice channel).</li>
                        <li><i>lock</i> - Locking your room (voice channel).</li>
                        <li><i>unlock</i> - Opening your room (voice channel).</li>
                        <li><i>permit</i> - Allowing a user to enter (voice channel).</li>
                        <li><i>reject</i> - Forbidding a user to enter (voice channel).</li>
                        <li><i>kick</i> - Kicking a user from the room (voice channel).</li>
                        <li><i>bitrate</i> - Changing bitrate (voice channel).</li>
                        <li><i>hide</i> - Hiding your room (voice channel).</li>
                        <li><i>view</i> - Viewing room (voice channel).</li>
                        <li><i>invite</i> - Inviting someone to your room (voice channel).</li>
                        <li><i>text-mute</i> - Forbidding a user to message in the text channel.</li>
                        <li><i>text-unmute</i> - Allowing a user to message in the text channel.</li>
                        <li><i>text-reject</i> - Forbidding a user to view the private text channel.</li>
                        <li><i>text-permit</i> - Allowing a user to view the private text channel.</li>
                    </ul>
                </p>
                <a id={"Commands"}><h1>Commands</h1></a>
                <p>
                    All commands in VRB use slashes. If you don’t know about slashed read <a href="https://support.discord.com/hc/en-us/articles/1500000368501-Slash-Commands-FAQ">this article</a>
                </p>
                <table>
                    <thead>
                    <tr>
                        <th>Command</th>
                        <th>Description</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>add-space</td>
                        <td>Adds new space (category and rooms)</td>
                    </tr>
                    <tr>
                        <td>remove-space</td>
                        <td>Removes created cpace</td>
                    </tr>
                    <tr>
                        <td>control-panel</td>
                        <td>Creates the message with buttons you can use to control your private room. You need to use this command in the channel you want to see the control panel in</td>
                    </tr>
                    <tr>
                        <td>set-default-rooms-count</td>
                        <td>Sets rooms count in special space</td>
                    </tr>
                    <tr>
                        <td>set-default-room-name</td>
                        <td>
                            Sets default name template for private rooms <br/>
                            Template it's just string with some keys which will have been changed to: <br/>
                            <ul>
                                <li>{"{"}user{"}"} - user nickname</li>
                                <li>{"{"}custom{"}"} - users own text. /name command</li>
                                <li>{"{"}number{"}"} - serial number in space</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>set-default-limit</td>
                        <td>Sets default users limit per room or on the server</td>
                    </tr>
                    <tr>
                        <td>set-default-bitrate</td>
                        <td>Sets default sound bitrate per room or on the server</td>
                    </tr>
                    <tr>
                        <td>permissions</td>
                        <td>Shows the main or special permissions</td>
                    </tr>
                    <tr>
                        <td>add-permission</td>
                        <td>Adds main permission to server</td>
                    </tr>
                    <tr>
                        <td>remove-permission</td>
                        <td>Removes the main server permission</td>
                    </tr>
                    <tr>
                        <td>enable-special</td>
                        <td>Sets special permission for user or role</td>
                    </tr>
                    <tr>
                        <td>disable-special</td>
                        <td>Resets special permission for user or role</td>
                    </tr>
                    <tr>
                        <td>remove-special-permissions</td>
                        <td>Resets all special permissions for user or role</td>
                    </tr>
                    <tr>
                        <td>command–channels</td>
                        <td>Shows or sets command text channel. Channel where u can use bot commands</td>
                    </tr>
                    <tr>
                        <td>remove-command–channel</td>
                        <td>Removes command channel from enabled pool</td>
                    </tr>
                    <tr>
                        <td>help</td>
                        <td>Help command</td>
                    </tr>
                    <tr>
                        <td>name</td>
                        <td>Change name</td>
                    </tr>
                    <tr>
                        <td>limit</td>
                        <td>Changes users limit in your private room</td>
                    </tr>
                    <tr>
                        <td>bitrate</td>
                        <td>Changes sound bitrate in your private room</td>
                    </tr>
                    <tr>
                        <td>mute</td>
                        <td>Mutes user. (kicks users before mute)</td>
                    </tr>
                    <tr>
                        <td>unmute</td>
                        <td>Unmute user</td>
                    </tr>
                    <tr>
                        <td>kick</td>
                        <td>Kicks user from from your private room</td>
                    </tr>
                    <tr>
                        <td>lock</td>
                        <td>Locks your room for @everyone</td>
                    </tr>
                    <tr>
                        <td>unlock</td>
                        <td>Locks your room for @everyone</td>
                    </tr>
                    <tr>
                        <td>permit</td>
                        <td>Permits user to visit your room</td>
                    </tr>
                    <tr>
                        <td>reject</td>
                        <td>Prevent user to  enter the room</td>
                    </tr>
                    <tr>
                        <td>hide</td>
                        <td>Locks your room for @everyone</td>
                    </tr>
                    <tr>
                        <td>view</td>
                        <td>View your room for everyone</td>
                    </tr>
                    <tr>
                        <td>invite</td>
                        <td>Invite selected user to your private room</td>
                    </tr>
                    <tr>
                        <td>create-text</td>
                        <td>Creates text channel for your private room</td>
                    </tr>
                    <tr>
                        <td>remove-text</td>
                        <td>Removes text channel for your private room</td>
                    </tr>
                    <tr>
                        <td>text-mute</td>
                        <td>Mute someone in your private text channel</td>
                    </tr>
                    <tr>
                        <td>text-unmute</td>
                        <td>Unmute someone in your private text channel</td>
                    </tr>
                    <tr>
                        <td>text-permit</td>
                        <td>Permit someone in your private text channel</td>
                    </tr>
                    <tr>
                        <td>text-reject</td>
                        <td>Prevent someone in your private text channel</td>
                    </tr>
                    <tr>
                        <td>start-premium</td>
                        <td>Start premium on your server</td>
                    </tr>
                    <tr>
                        <td>server-plan</td>
                        <td>Check your current subscription on your server</td>
                    </tr>
                    <tr>
                        <td>my-plans</td>
                        <td>Check your plans</td>
                    </tr>
                    </tbody>
                </table>
                <a id="Premium"><h1>Premium</h1></a>
                <p>
                    Not all commands are free. Some commands you can get with Patreon donations. <br/>
                    Premium contains the following features (for one server): <br/>
                    <ul>
                        <li>Create as many as you with active spaces</li>
                        <li>Creating text channels</li>
                        <li>Setting up special permissions and main permissions for specific space.</li>
                    </ul>
                </p>
                <p>
                    To use premium functions you need to be a VRB support server member and have a <a href="https://patreon.com/vrb">Patreon</a> account. <br/>
                    The bot has an account system. After getting premium you can check it with the /my-plans command within your server. <br/>
                    To activate premium on your server you need to be a server owner. Use /start-premium command to activate premium <br/>
                    To check active server premium use /server-plan command <br/>
                </p>
                <p>
                    The subscription fee is charged immediately. The current plan will be active per month. <br/>
                    After the expiration date, subscription payment will be charged one more time. <br/>
                    If you unsubscribe the features will be disabled after the expiration date. <br/>
                </p>
            </div>
        </div>
    )
}
